module.exports = __webpack_public_path__ + "img/chara_line_2.bccf73ad.png";